<template>
    <header class="sps-shell-header" :class="`is-${variant}`" :style="headerStyle">
        <div class="sps-shell-header__row">
            <img v-if="variant === 'home' && logo" :src="logo" alt="" class="sps-shell-header__logo" />
            <span v-else-if="variant === 'home'" class="sps-shell-header__brand">{{ organizationName }}</span>
            <span v-else class="sps-shell-header__title">{{ title }}</span>
            <div class="sps-shell-header__right">
                <div v-if="variant === 'home' && avatars.length" class="sps-shell-header__avatars">
                    <span v-for="a in avatars" :key="a.userId" class="sps-avatar" :title="a.name"><img v-if="a.avatarUrl" :src="a.avatarUrl" alt="" /><span v-else>{{ initial(a.name) }}</span></span>
                </div>
                <button type="button" class="sps-shell-header__close" :aria-label="$t('message.close')" @click="$emit('close')">
                    <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" /></svg>
                </button>
            </div>
        </div>
        <div v-if="variant === 'home'" class="sps-shell-header__greeting">
            <div class="sps-shell-header__g1" :style="textStyle('greetingSize')">{{ greeting }}</div>
            <div class="sps-shell-header__g2" :style="textStyle('headlineSize')">{{ headline }}</div>
        </div>
    </header>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { pickLanguageContent } from "../../../utils/shell/pickLanguageContent";
import { imageModeOf, imageBackground } from "../../../utils/shell/homeBackground";
const isLightHex = (hex) => {
    let h = String(hex).replace("#", "");
    if (h.length === 3) h = h.split("").map((c) => c + c).join("");
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6;
};
export default {
    name: "ShellHeader",
    props: { variant: { type: String, default: "plain" }, title: { type: String, default: "" } },
    computed: {
        ...mapGetters({ config: "shell/config" }),
        ...mapState({ settings: (s) => s.setting.settings, defaultLocale: (s) => s.catalog.defaultLocale }),
        organizationName() { return this.settings.organizationName || ""; },
        // web chat'e ozel logo yoksa sirket ayarlarindaki logo
        logo() { if (this.config.header.logoUrl) return this.config.header.logoUrl; const a = this.settings.organizationLogo; if (!a) return ""; return a.v2Format && a.cdnUrl ? a.cdnUrl : a.path ? `https://static.supsis.live/${a.path}${a.id}.${a.ext}` : ""; },
        avatars() { return this.config.header.showTeamAvatars ? (this.config.header.teamAvatars || []).slice(0, 3) : []; },
        lc() { return pickLanguageContent(this.config.header.languageContent, this.$i18n.locale, this.defaultLocale) || {}; },
        greeting() { return this.lc.greeting || this.$t("shell.greeting"); },
        headline() { return this.lc.headline || this.$t("shell.headline"); },
        headerStyle() {
            const h = this.config.header;
            if (this.variant !== "home") return {};
            const mode = imageModeOf(h);
            // tum sayfa modunda gorsel ana sayfanin arkasinda (HomeView); baslik saydam kalir
            if (mode === "full") return { background: "transparent" };
            if (mode === "header") return imageBackground(h, "linear-gradient(180deg, rgba(0,0,0,.15), rgba(0,0,0,.45))");
            if (h.style === "solid") {
                if (!h.color) return { background: "var(--button-color, #4f46e5)" };
                // Acik renk secildiyse beyaz yazi okunmaz; koyu metne gec
                return { background: h.color, color: isLightHex(h.color) ? "#1f2337" : "#fff" };
            }
            // Gradyan: renk secildiyse ondan, secilmediyse tema buton renginden acigina dogru
            const base = h.color || "var(--button-color, #4f46e5)";
            return { background: `linear-gradient(135deg, ${base}, color-mix(in srgb, ${base} 55%, #fff))`, ...(h.color && isLightHex(h.color) ? { color: "#1f2337" } : {}) };
        },
    },
    methods: {
        initial(n) { return String(n || "?").trim().charAt(0).toUpperCase(); },
        // panelden ayarlanan yazi boyutu ve satir araligi; ayar yoksa CSS varsayilani gecerli
        textStyle(sizeKey) {
            const h = this.config.header;
            return { ...(h[sizeKey] ? { fontSize: `${h[sizeKey]}px` } : {}), ...(h.lineHeight ? { lineHeight: h.lineHeight } : {}) };
        },
    },
};
</script>
<style lang="scss">
.sps-shell-header { flex-shrink: 0; color: #fff; background-size: cover; background-position: center;
    &.is-plain { color: var(--primary-text, #1f2337); background: var(--background-color-first, #fff); border-bottom: 1px solid var(--sps-border, rgba(15, 23, 42, 0.08)); }
    &__row { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; }
    &.is-home &__row { padding-bottom: 0; }
    &__brand, &__title { font-weight: 600; font-size: 15px; }
    &__title { flex: 1; text-align: center; }
    // genel img kurallari yuksekligi ezmesin; logo her boyutta bantta sabit yukseklikte kalir
    & img.sps-shell-header__logo { height: 28px; width: auto; max-width: 140px; object-fit: contain; }
    &__right { display: flex; align-items: center; gap: 10px; }
    &__avatars { display: flex; .sps-avatar { width: 30px; height: 30px; margin-left: -8px; border-radius: 50%; border: 2px solid #fff; background: #c7d2fe; color: #312e81; display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 600; overflow: hidden; img { width: 100%; height: 100%; object-fit: cover; } } }
    &__close { width: 32px; height: 32px; border: 0; border-radius: 8px; background: rgba(255, 255, 255, 0.18); color: inherit; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; svg { width: 18px; height: 18px; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; } }
    &.is-plain &__close { background: rgba(15, 23, 42, 0.06); }
    &__greeting { padding: 22px 20px 64px; }
    &__g1 { font-size: 22px; line-height: 1.3; opacity: 0.92; }
    &__g2 { font-size: 24px; line-height: 1.25; font-weight: 700; margin-top: 4px; }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/ShellHeader.vue